import { BlockDiagramEdge } from './Edge'

export default function edgeRouter({ edge, onEdgeClick, theme = null }) {
  return <BlockDiagramEdge onEdgeClick={onEdgeClick} theme={theme} />
}
